import React from 'react'

interface IconProps {
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

export const Scan: React.FC<IconProps> = ({
  color = '#7572FF',
  size = 20,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M16.667 13.333c.46 0 .833.373.833.834V16.5a1 1 0 01-1 1h-13a1 1 0 01-1-1v-2.333a.833.833 0 111.667 0v1.666h11.666v-1.666c0-.46.373-.834.834-.834zM2.5 10c0-.46.373-.833.833-.833h13.334a.833.833 0 010 1.666H3.333A.833.833 0 012.5 10zm15-4.167a.833.833 0 11-1.667 0V4.167H4.167v1.666a.833.833 0 01-1.667 0V3.5a1 1 0 011-1h13a1 1 0 011 1v2.333z"
      fill={color}
    />
  </svg>
)
